// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".EsMmrYCzHBiJTPbJgLP7{display:flex;flex-direction:column;align-items:center;justify-content:center}", "",{"version":3,"sources":["webpack://./src/components/LoadingPage/LoadingPage.module.scss"],"names":[],"mappings":"AAGA,sBACE,YAAA,CACA,qBAAA,CACA,kBAAA,CACA,sBAAA","sourcesContent":["@use '../../styles/fonts' as *;\n@use '../../styles/theme' as *;\n\n.container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": "EsMmrYCzHBiJTPbJgLP7"
};
export default ___CSS_LOADER_EXPORT___;
